import '.cq{font-size:1.125rem;}.ssr-plugin'
import '.f6{line-height:1.75rem;}.ssr-plugin'
import '.b5{text-decoration:none;}.ssr-plugin'
import '.ek{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cq f6"
    >
      {translations.privacySubtitle}{' '}
      <a className="b5 ek"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="b5 ek"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
